export type IssueLegendMode = 'show-all' | 'reset';

export const getLegendResetUiState = ({
  hiddenCount,
  isResetEnabled,
  mode,
}: {
  hiddenCount: number;
  isResetEnabled?: boolean;
  mode?: IssueLegendMode;
}): {
  disabled: boolean;
  label: string;
  shouldShow: boolean;
} => {
  const resolvedMode = mode ?? 'show-all';
  const resetEnabled = isResetEnabled ?? false;

  if (resolvedMode === 'reset') {
    return {
      disabled: !resetEnabled,
      label: hiddenCount > 0 ? `Reset (${hiddenCount} hidden)` : 'Reset',
      shouldShow: hiddenCount > 0 || resetEnabled,
    };
  }

  return {
    disabled: false,
    label: `Show All (${hiddenCount} hidden)`,
    shouldShow: hiddenCount > 0,
  };
};
